export enum AddPotentialBeneficiaryModalSteps {
  RelationshipInfo = 'relationshipInfo',
  PersonDetails = 'personDetails',
  BusinessDetails = 'businessDetails',
  AddressInfo = 'addressInfo',
  ContactInfo = 'contactInfo',
  PaymentInfo = 'paymentInfo',
}
